import api from "./api.js";
import activeTool from "./activeTool.js";
import plugins from "./plugins.js";
import storage from "./storage/index.js";
import user from "./user.js";
import workspace from "./workspace.js";
import defaultWorkspaceSettings from "./defaultWorkspaceSettings.js";
import serverConfigValues from "./serverConfigValues.js";
var reducers = {
  activeTool,
  api,
  plugins,
  storage,
  user,
  workspace,
  defaultWorkspaceSettings,
  serverConfigValues
};
export default reducers;
//# sourceMappingURL=index.js.map